<div id="tabs-list" class="mb-4">
    <button
        *ngFor="let tab of tabs"
        class="tab eu-mx_2"
        type="button"
        [ngClass]="{ 'selected-tab': selectedTabId === tab.id }"
        (click)="handleTabChange(tab.id)"
        [attr.data-cy]="'tab-id-' + tab.id"
    >
        {{ tab.label }}
    </button>
</div>
